import { post } from '@/api/request'

export default {
  upgradeAccount: (payload, success, failure) => post(
    '/api/account/upgrade',
    payload, success, failure
  ),
  
  startTrial: (success, failure) => post(
    '/api/account/start-trial',
    {}, success, failure
  ),
  
  verifyPayment: (payload, success, failure) => post(
    '/api/account/upgrade/verify-payment',
    payload, success, failure
  ),
  
  deleteCard: (cardId, success, failure) => post(
    `/api/account/card/${cardId}/delete`,
    {}, success, failure
  ),
}